import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getData } from "../../services/FetchNodeServices";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const ITEMS_PER_PAGE = 10;

const AllEnquiry = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 0, currentPage: 1 });
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);

  const fetchEnquiries = async (page = 1) => {
    try {
      const res = await getData(`enquiry/get-all-enquiry?limit=${ITEMS_PER_PAGE}&page=${page}`);
      if (res?.status) {
        setData(res.data || []);
        setPagination(res.pagination || { total: 0, totalPages: 0, currentPage: 1 });
      } else {
        toast.error("Failed to fetch enquiries.");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong while fetching enquiries.");
    }
  };

  useEffect(() => {
    fetchEnquiries(pagination.currentPage);
  }, [pagination.currentPage]);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this enquiry?")) return;
    try {
      const res = await getData(`enquiry/delete-enquiry/${id}`);
      if (res?.status) {
        toast.success("Enquiry deleted successfully.");
        fetchEnquiries(pagination.currentPage);
      } else {
        toast.error("Failed to delete enquiry.");
      }
    } catch (err) {
      toast.error("Server error while deleting.");
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.totalPages) {
      setPagination((prev) => ({ ...prev, currentPage: page }));
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date) ? "—" : date.toLocaleDateString("en-IN", { dateStyle: "medium" });
  };

  const renderPaginationButtons = () => {
    const { currentPage, totalPages } = pagination;
    const pages = [];
    const pagesToShow = 3; // how many pages to show in the middle

    if (totalPages > 0) { pages.push(1); }

    if (currentPage > pagesToShow + 2) { pages.push("..."); }
    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);

    for (let i = startPage; i <= endPage; i++) {
      if (i > 1 && i < totalPages) {
        pages.push(i);
      }
    }

    if (currentPage < totalPages - (pagesToShow + 1)) {
      pages.push("...");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return (
      <div className="d-flex justify-content-center mt-3 gap-2 flex-wrap">
        <button className="btn btn-sm btn-outline-dark" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}      >
          Previous
        </button>

        {pages.map((page, index) =>
          page === "..." ? (
            <span key={`ellipsis-${index}`} className="px-2">...</span>
          ) : (
            <button key={page} className={`btn btn-sm ${currentPage === page ? "btn-dark" : "btn-outline-dark"}`} onClick={() => handlePageChange(page)}          >
              {page}
            </button>
          )
        )}

        <button
          className="btn btn-sm btn-outline-dark"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <>
      <ToastContainer />
      <div className="bread">
        <div className="head">
          <h4>All Enquiries</h4>
        </div>
      </div>

      <section className="d-table">
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>City</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Status</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.id || index}>
                    <td>{(pagination.currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                    <td>{item?.name || "—"}</td>
                    <td>{item?.city || "—"}</td>
                    <td>{item?.phone || "—"}</td>
                    <td>{item?.email || "—"}</td>
                    <td>{item?.status ? "Active" : "Inactive"}</td>
                    <td>{formatDate(item?.create_date)}</td>
                    <td className="d-flex flex-column gap-1">
                      <button
                        className="btn btn-sm btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#viewMessageModal"
                        onClick={() => setSelectedEnquiry(item)}
                      >
                        View Message
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No enquiries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {pagination.totalPages > 1 && renderPaginationButtons()}
      </section>

      {/* Modal */}
      <div
        className="modal fade"
        id="viewMessageModal"
        tabIndex="-1"
        aria-labelledby="viewMessageModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="viewMessageModalLabel">
                Enquiry Details
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {selectedEnquiry ? (
                <div>
                  <p><strong>Name:</strong> {selectedEnquiry.name}</p>
                  <p><strong>Email:</strong> {selectedEnquiry.email}</p>
                  <p><strong>Phone:</strong> {selectedEnquiry.phone}</p>
                  <p><strong>City:</strong> {selectedEnquiry.city}</p>
                  <p><strong>Date:</strong> {formatDate(selectedEnquiry.create_date)}</p>
                  <p style={{ whiteSpace: "pre-line" }}>
                    <strong>Message:</strong><br />{selectedEnquiry.message}
                  </p>
                </div>
              ) : (
                <p>No data found.</p>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllEnquiry;
